import { Pipe, PipeTransform } from '@angular/core';
import { toInitialUpperCase } from '../utilities/string.util';

@Pipe({
  name: 'firstCapital',
})
export class FirstCapitalPipe implements PipeTransform {
  transform(value: string | null): string {
    if (value === null) {
      return '';
    }

    return toInitialUpperCase(value);
  }
}
